(function startSCConfigurator(){
if(!document.getElementById('sc-configurator')) return;
if(typeof fabric==='undefined'){setTimeout(startSCConfigurator,100);return;}
let PRINT_W_CM=30, PRINT_H_CM=40;
let activeQuickZone='full';
const quickZones={front:'full',back:'full',leftSleeve:'sleeve',rightSleeve:'sleeve'};
const canvasEl=document.getElementById('designCanvas');
const box=document.querySelector('.canvas-box');
const canvas=new fabric.Canvas('designCanvas',{preserveObjectStacking:true,selection:true});
const states={front:null,back:null,leftSleeve:null,rightSleeve:null};
const history={front:[],back:[],leftSleeve:[],rightSleeve:[]}, future={front:[],back:[],leftSleeve:[],rightSleeve:[]};
let side='front', shirtColor='100', restoring=false, snapLock=false;
let currentProduct=null, currentColor=null;
function isJogger(){return currentProduct?.kind==='jogger'}
function isSleeveSurface(whichSide=side){return whichSide==='leftSleeve'||whichSide==='rightSleeve'}
function activeSurfaceKeys(){return isJogger()?['front','back']:['front','back','leftSleeve','rightSleeve']}
function surfaceLabel(whichSide){
  if(isJogger()) return whichSide==='front'?'Hosenbein links':'Hosenbein rechts';
  if(whichSide==='leftSleeve') return 'Ärmel links';
  if(whichSide==='rightSleeve') return 'Ärmel rechts';
  return whichSide==='front'?'Vorderseite':'Rückseite';
}
function ensureSurfaceButtons(){
  const first=document.querySelector('.seg');
  const wrap=first?.parentElement;
  if(!wrap)return;
  for(const [key,label] of [['leftSleeve','Ärmel links'],['rightSleeve','Ärmel rechts']]){
    if(wrap.querySelector(`.seg[data-side="${key}"]`))continue;
    const b=document.createElement('button');
    b.type='button';b.className='seg';b.dataset.side=key;b.textContent=label;
    wrap.appendChild(b);
  }
}
function refreshSurfaceLabels(){
  ensureSurfaceButtons();
  const buttons=[...document.querySelectorAll('.seg')];
  buttons.forEach(b=>{
    b.textContent=surfaceLabel(b.dataset.side);
    if(isSleeveSurface(b.dataset.side)) b.style.display=isJogger()?'none':'';
  });
  const frontPrice=document.getElementById('frontPrice');
  const backPrice=document.getElementById('backPrice');
  if(frontPrice?.parentElement?.firstElementChild) frontPrice.parentElement.firstElementChild.textContent=isJogger()?'Druck '+surfaceLabel('front'):'Druck Vorderseite + Ärmel';
  if(backPrice?.parentElement?.firstElementChild) backPrice.parentElement.firstElementChild.textContent='Druck '+surfaceLabel('back');
}
const originalUploads=new Map();
let uploadSequence=0;
const SIZE_ORDER=['XXS','XS','S','M','L','XL','XXL','3XL','4XL','5XL'];
const SIZE_CHEST_CM={XXS:42,XS:46,S:50,M:54,L:58,XL:62,XXL:66,'3XL':70,'4XL':74,'5XL':78};
const SIZE_SAFE_WIDTH_CM={XXS:26,XS:28,S:30,M:32,L:34,XL:36,XXL:38,'3XL':40,'4XL':42,'5XL':44};


const UM_COLORS_ALL=[
 {code:'100',name:'White',hex:'#f5f5f3'},{code:'120',name:'Grey Melange',hex:'#aaa9a5'},{code:'170',name:'Birch',hex:'#e9dfcf'},
 {code:'179',name:'Latte',hex:'#b8a286'},{code:'205',name:'Ray',hex:'#d8ad47'},{code:'480',name:'Brick',hex:'#a65445'},
 {code:'490',name:'Prune',hex:'#63394f'},{code:'505',name:'Aster',hex:'#a6a4c3'},{code:'510',name:'Fog',hex:'#96a3a7'},
 {code:'600',name:'Navy',hex:'#24344b'},{code:'626',name:'Orion (387000)',hex:'#45646a'},{code:'750',name:'Sage',hex:'#93a18d'},
 {code:'760',name:'Thyme',hex:'#737b68'},{code:'900',name:'Black (9',hex:'#202020'},{code:'940',name:'Charocal (940)',hex:'#56595b'}
];
const UM_COLORS_LOOSE=UM_COLORS_ALL.filter(c=>['170','600','900','940'].includes(c.code));
const UM_PRODUCTS=[
 {id:'3410010',name:'UM T-Shirt (OCS) Regular Fit Unisex',price:12.00,sizes:['XXS','XS','S','M','L','XL','XXL','3XL','4XL','5XL'],colors:UM_COLORS_ALL,kind:'tshirt',print:{w:30,h:40},handle:'um-t-shirt-ocs-regular-fit-unisex',img:'3410010-{code}_UMT-shirtRegularfit_{side}.jpg',fallback:'https://www.swiss-crafting.ch/cdn/shop/files/3410010-100_UMT-shirtRegularfit_front.jpg?v=1765281151&width=1200'},
 {id:'3440010',name:'UM Hoodie (OCS-RCS) Regular Fit Unisex',price:35.00,sizes:['XXS','XS','S','M','L','XL','XXL','3XL','4XL','5XL'],colors:UM_COLORS_ALL,kind:'hoodie',print:{w:30,h:32},handle:'um-hoodie-ocs-rcs-regular-fit-unisex',img:'3440010-{code}_UMHoodieRegularFit_{side}.jpg',fallback:'https://www.swiss-crafting.ch/cdn/shop/files/3440010-100_UMHoodieRegularFit_front_7b7d61fc-e1ca-4f2e-a661-365dfe933412.jpg?v=1765244896&width=1200'},
 {id:'3430020',name:'UM Crewneck (OCS-RCS) Loose Fit Unisex',price:33.00,sizes:['XXS','XS','S','M','L','XL','XXL','3XL'],colors:UM_COLORS_LOOSE,kind:'crewneck',print:{w:30,h:35},handle:'um-crewneck-ocs-rcs-loose-fit-unisex',img:'3430020-{code}_UMCrewneckLooseFit_{side}.jpg',fallback:'https://www.swiss-crafting.ch/cdn/shop/files/3430020-170_UMCrewneckLooseFit_front.jpg?v=1765374200&width=1200'},
 {id:'3430010',name:'UM Crewneck (OCS-RCS) Regular Fit Unisex',price:26.00,sizes:['XXS','XS','S','M','L','XL','XXL','3XL','4XL','5XL'],colors:UM_COLORS_ALL,kind:'crewneck',print:{w:30,h:35},handle:'um-crewneck-ocs-rcs-regular-fit-unisex',img:'3430010-{code}_UMCrewneckRegularFit_{side}.jpg',fallback:'https://www.swiss-crafting.ch/cdn/shop/files/3430010-100_UMCrewneckRegularFit_front.jpg?v=1766486556&width=1200'},
 {id:'3410020',name:'UM T-Shirt (OCS) Loose Fit Unisex',price:15.00,sizes:['XXS','XS','S','M','L','XL','XXL','3XL'],colors:UM_COLORS_LOOSE,kind:'tshirt',print:{w:30,h:40},handle:'um-t-shirt-ocs-loose-fit-unisex',img:'3410020-{code}_UMT-shirtLooseFit_{side}.jpg',fallback:'https://www.swiss-crafting.ch/cdn/shop/files/3410020-170_UMT-shirtLooseFit_front_7912fc83-b21f-439d-bff1-82facf521b6f.jpg?v=1765371219&width=1200'},
 {id:'3420010',name:'UM Polo (OCS) Regular Fit Unisex',price:21.00,sizes:['XXS','XS','S','M','L','XL','XXL','3XL','4XL','5XL'],colors:UM_COLORS_ALL,kind:'polo',print:{w:28,h:35},handle:'um-polo-ocs-regular-fit-unisex',img:'3420010-{code}_UMPoloRegularFit_{side}.jpg',fallback:'https://www.swiss-crafting.ch/cdn/shop/files/3420010-100_UMPoloRegularFit_front_a41c5243-bab8-4a03-8288-8c490b6352ed.jpg?v=1765274648&width=1200'},
 {id:'3460010',name:'UM Jogger Pants (OCS-RCS) Unisex',price:36.50,sizes:['XXS','XS','S','M','L','XL','XXL','3XL'],colors:UM_COLORS_LOOSE,kind:'jogger',print:{w:12,h:25},handle:'um-jogger-pants-ocs-rcs-unisex',img:'3460010-{code}_UMJoggerPants_{side}.jpg',fallback:'https://www.swiss-crafting.ch/cdn/shop/files/3460010-170_UMJoggerPants_front_20054df0-7339-4801-98b5-5a01fefdfcc9.jpg?v=1765274186&width=1200'},
 {id:'3450010',name:'UM Full Zip Hoodie (OCS-RCS) Regular Fit Unisex',price:59.00,sizes:['XXS','XS','S','M','L','XL','XXL','3XL','4XL','5XL'],colors:UM_COLORS_ALL,kind:'fullzip',print:{w:28,h:30},handle:'um-full-zip-hoodie-ocs-rcs-regular-fit-unisex',img:'3450010-{code}_UMFullzipHoodieRegularFit_{side}.jpg',fallback:'https://www.swiss-crafting.ch/cdn/shop/files/3450010-100_UMFullzipHoodieRegularFit_front.jpg?v=1765273865&width=1200'},
 {id:'3440020',name:'UM Hoodie (OCS-RCS) Loose Fit Unisex',price:43.00,sizes:['XXS','XS','S','M','L','XL','XXL','3XL'],colors:UM_COLORS_LOOSE,kind:'hoodie',print:{w:30,h:32},handle:'um-hoodie-ocs-rcs-loose-fit-unisex',img:'3440020-{code}_UMHoodieLooseFit_{side}.jpg',fallback:'https://www.swiss-crafting.ch/cdn/shop/files/3440020-170_UMHoodieLooseFit_front_5bcefa2c-ad20-45b7-81c1-49bdd3924c17.jpg?v=1765272795&width=1200'}
];
function productImageUrl(p,color,whichSide=side){
 // Bei Hosen werden beide Hosenbein-Druckflächen auf der Vorderansicht gezeigt.
 const sideName=p.kind==='jogger'?'front':(whichSide==='back'?'back':'front');
 return 'https://www.swiss-crafting.ch/cdn/shop/files/'+p.img.replace('{code}',color.code).replace('{side}',sideName)+'?width=1200';
}
function renderProductOptions(){const sel=document.getElementById('productSelect');const requested=new URLSearchParams(location.search).get('product');sel.innerHTML=UM_PRODUCTS.map((p,i)=>`<option value="${p.id}" ${(requested?p.handle===requested:i===0)?'selected':''}>${p.name}</option>`).join('')}
function renderColors(){const el=document.getElementById('shirtColors');el.innerHTML=currentProduct.colors.map((c,i)=>`<button class="swatch ${currentColor&&c.code===currentColor.code?'active':''}" data-code="${c.code}" title="${c.name} (${c.code})" style="background:${c.hex}"></button>`).join('');document.getElementById('colorName').textContent=`${currentColor.name} (${currentColor.code})`}
function renderSizes(){const q=document.getElementById('qtyGrid');q.innerHTML=currentProduct.sizes.map((size,i)=>`<label>${size}<input type="number" min="0" value="${i===Math.min(3,currentProduct.sizes.length-1)?1:0}" class="qty" data-size="${size}"></label>`).join('');q.querySelectorAll('.qty').forEach(i=>i.oninput=()=>{applyPrintArea();renderQuickPositions();calcPrice();updateProductionStatus();updatePrintChargeStatus();refreshShopifyStatus()})}
function renderProductMeta(){document.getElementById('productMeta').innerHTML=`<span class="meta-chip">Art. ${currentProduct.id}</span><span class="meta-chip">Unisex</span><span class="meta-chip">${currentProduct.sizes[0]}–${currentProduct.sizes[currentProduct.sizes.length-1]}</span>`}
function updateProductPhoto(){const img=document.getElementById('productPhoto');img.onerror=()=>{img.onerror=null;img.src=currentProduct.fallback};img.src=productImageUrl(currentProduct,currentColor,side);img.alt=`${currentProduct.name} – ${currentColor.name} – ${surfaceLabel(side)}`}

function serialize(){
  canvas.getObjects().forEach(o=>{
    const r=o.getBoundingRect(true,true);
    o.productionXcm=pxToCmX(r.left);
    o.productionYcm=pxToCmY(r.top);
    o.productionWcm=pxToCmX(r.width);
    o.productionHcm=pxToCmY(r.height);
  });

  return JSON.stringify(canvas.toJSON([
    'name',
    'sourcePxW',
    'sourcePxH',
    'isVector',
    'uploadId',
    'originalName',
    'originalType',
    'originalSize',
    'printPosition',
    'productionXcm',
    'productionYcm',
    'productionWcm',
    'productionHcm'
  ]));
}
function pushHistory(){if(restoring)return; const data=serialize(); const h=history[side]; if(h[h.length-1]!==data){h.push(data);if(h.length>40)h.shift();future[side]=[]} updateUndoButtons()}
function updateUndoButtons(){document.getElementById('undoBtn').disabled=history[side].length<2;document.getElementById('redoBtn').disabled=!future[side].length}
function restore(data){restoring=true;canvas.loadFromJSON(data,()=>{canvas.renderAll();restoring=false;refreshLayers();syncSelection();calcPrice();updatePrintInfo()})}
function undo(){const h=history[side];if(h.length<2)return;future[side].push(h.pop());restore(h[h.length-1]);updateUndoButtons()}
function redo(){const f=future[side];if(!f.length)return;const d=f.pop();history[side].push(d);restore(d);updateUndoButtons()}

function sizeCanvas(){
  const measuredW=box.clientWidth||box.getBoundingClientRect().width;
  const measuredH=box.clientHeight||box.getBoundingClientRect().height;
  const oldW=canvas.getWidth()||measuredW,oldH=canvas.getHeight()||measuredH;
  const newW=Math.max(1,Math.round(measuredW)),newH=Math.max(1,Math.round(measuredH));

  if(oldW&&oldH&&canvas.getObjects().length){
    const sx=newW/oldW,sy=newH/oldH;
    canvas.getObjects().forEach(o=>{
      o.scaleX*=sx;
      o.scaleY*=sy;
      o.left*=sx;
      o.top*=sy;
      o.setCoords();
    });
  }

  canvas.setWidth(newW);
  canvas.setHeight(newH);
  canvas.renderAll();
  updatePrintInfo();
}
function pxToCmX(px){return px/canvas.width*PRINT_W_CM} function pxToCmY(px){return px/canvas.height*PRINT_H_CM}
function cmToPxX(cm){return cm/PRINT_W_CM*canvas.width} function cmToPxY(cm){return cm/PRINT_H_CM*canvas.height}

function saveSide(){states[side]=serialize()}
function loadSide(next){
  saveSide();
  quickZones[side]=activeQuickZone;
  if(isJogger()&&isSleeveSurface(next)) next='front';
  side=next;
  activeQuickZone=quickZones[side]||'full';
  canvas.clear();
  const data=states[side];
  if(data){
    restoring=true;
    canvas.loadFromJSON(data,()=>{
      restoring=false;canvas.renderAll();refreshLayers();
      if(!history[side].length)history[side]=[serialize()];
      updateUndoButtons();updatePrintInfo();
    });
  }else{
    history[side]=[serialize()];future[side]=[];refreshLayers();updateUndoButtons();updatePrintInfo();
  }
  document.getElementById('sideTitle').textContent=surfaceLabel(side)+' gestalten';
  document.querySelectorAll('.seg').forEach(b=>b.classList.toggle('active',b.dataset.side===side));
  refreshSurfaceLabels();
  renderQuickPositions();applyPrintArea();updateProductPhoto();calcPrice();
  setTimeout(refreshShopifyStatus,50);
}
ensureSurfaceButtons();
document.querySelectorAll('.seg').forEach(b=>b.onclick=()=>loadSide(b.dataset.side));

function addText(){const t=new fabric.Textbox(document.getElementById('textInput').value||'Dein Text',{left:25,top:30,width:180,fontSize:30,fontFamily:document.getElementById('fontFamily').value,fill:'#111',fontWeight:'700',textAlign:'center',name:'Text',strokeWidth:0,stroke:'#fff',printPosition:(document.getElementById('specialPosition')?.value||'standard')});canvas.add(t).setActiveObject(t);canvas.centerObjectH(t);t.setCoords();canvas.renderAll();pushHistory();refreshLayers();calcPrice();syncSelection()}
document.getElementById('addText').onclick=addText;
document.getElementById('textInput').addEventListener('input',e=>{const o=canvas.getActiveObject();if(o&&o.type==='textbox'){o.set('text',e.target.value);canvas.renderAll();updatePrintInfo()}});
document.getElementById('textInput').addEventListener('change',pushHistory);
document.getElementById('fontFamily').onchange=e=>{const o=canvas.getActiveObject();if(o&&o.type==='textbox'){o.set('fontFamily',e.target.value);canvas.renderAll();pushHistory()}};

document.getElementById('uploadTrigger').onclick=()=>document.getElementById('upload').click();
document.getElementById('upload').onchange=e=>{
 const file=e.target.files[0];if(!file)return;
 const uploadId='UP-'+Date.now()+'-'+(++uploadSequence);
 originalUploads.set(uploadId,file);
 document.getElementById('originalCount').textContent=originalUploads.size;
 const reader=new FileReader();
 reader.onload=ev=>{
   fabric.Image.fromURL(ev.target.result,img=>{
     const maxW=canvas.width*.72,maxH=canvas.height*.72;
     img.scale(Math.min(maxW/img.width,maxH/img.height,1));
     img.set({
       left:canvas.width/2,top:canvas.height/2,originX:'center',originY:'center',
       name:file.name,sourcePxW:img.width,sourcePxH:img.height,isVector:file.type==='image/svg+xml',
       uploadId,originalName:file.name,originalType:file.type,originalSize:file.size,printPosition:(document.getElementById('specialPosition')?.value||'standard')
     });
     canvas.add(img).setActiveObject(img);canvas.renderAll();pushHistory();refreshLayers();calcPrice();syncSelection();updatePrintInfo();updateProductionStatus();
   });
 };
 reader.readAsDataURL(file);e.target.value=''
};

document.getElementById('centerObj').onclick=()=>{const o=canvas.getActiveObject();if(o){canvas.centerObject(o);o.setCoords();keepObjectInsideCanvas(o);canvas.renderAll();pushHistory();syncSelection()}};
document.getElementById('deleteObj').onclick=()=>deleteActive();
function deleteActive(){const o=canvas.getActiveObject();if(o){canvas.remove(o);canvas.discardActiveObject();canvas.renderAll();pushHistory();refreshLayers();calcPrice();syncSelection()}}
function duplicateActive(){const o=canvas.getActiveObject();if(!o)return;o.clone(c=>{c.set({left:(o.left||0)+14,top:(o.top||0)+14,name:(o.name||o.type)+' Kopie'});canvas.add(c).setActiveObject(c);canvas.renderAll();pushHistory();refreshLayers();syncSelection()})}

document.getElementById('undoBtn').onclick=undo;document.getElementById('redoBtn').onclick=redo;document.getElementById('duplicateBtn').onclick=duplicateActive;
document.addEventListener('keydown',e=>{if((e.ctrlKey||e.metaKey)&&e.key.toLowerCase()==='z'){e.preventDefault();e.shiftKey?redo():undo()}if((e.ctrlKey||e.metaKey)&&e.key.toLowerCase()==='d'){e.preventDefault();duplicateActive()}if((e.key==='Delete'||e.key==='Backspace')&&!['INPUT','TEXTAREA'].includes(document.activeElement.tagName)){e.preventDefault();deleteActive()}});

document.getElementById('textColors').onclick=e=>{const b=e.target.closest('.swatch');if(!b)return;document.querySelectorAll('#textColors .swatch').forEach(x=>x.classList.remove('active'));b.classList.add('active');const o=canvas.getActiveObject();if(o&&o.type==='textbox'){o.set('fill',b.dataset.color);canvas.renderAll();pushHistory()}};
document.getElementById('shirtColors').onclick=e=>{const b=e.target.closest('.swatch');if(!b)return;currentColor=currentProduct.colors.find(c=>c.code===b.dataset.code)||currentProduct.colors[0];shirtColor=currentColor.code;renderColors();updateProductPhoto();};

function refreshLayers(){const el=document.getElementById('layers'),objs=canvas.getObjects();if(!objs.length){el.innerHTML='<div class="tiny">Noch keine Gestaltung.</div>';return}el.innerHTML='';objs.slice().reverse().forEach(o=>{const d=document.createElement('div');d.className='layer'+(canvas.getActiveObject()===o?' active':'');const label=document.createElement('span');label.textContent=o.name||o.type;const actions=document.createElement('div');actions.className='layer-actions';const up=document.createElement('button');up.textContent='↑';up.title='Nach vorne';const down=document.createElement('button');down.textContent='↓';down.title='Nach hinten';const del=document.createElement('button');del.textContent='×';del.title='Löschen';actions.append(up,down,del);d.append(label,actions);label.onclick=()=>{canvas.setActiveObject(o);canvas.renderAll();syncSelection();refreshLayers()};up.onclick=()=>{canvas.bringForward(o);canvas.renderAll();pushHistory();refreshLayers()};down.onclick=()=>{canvas.sendBackwards(o);canvas.renderAll();pushHistory();refreshLayers()};del.onclick=()=>{canvas.remove(o);pushHistory();refreshLayers();calcPrice();syncSelection()};el.appendChild(d)})}

document.getElementById('bringForward').onclick=()=>{const o=canvas.getActiveObject();if(o){canvas.bringForward(o);canvas.renderAll();pushHistory();refreshLayers()}};
document.getElementById('sendBackward').onclick=()=>{const o=canvas.getActiveObject();if(o){canvas.sendBackwards(o);canvas.renderAll();pushHistory();refreshLayers()}};

function syncSelection(){const o=canvas.getActiveObject();const has=!!o;document.getElementById('noSelection').style.display=has?'none':'block';document.getElementById('objectProps').style.display=has?'block':'none';if(!has){updatePrintInfo();refreshLayers();return}if(o.type==='textbox'){document.getElementById('textInput').value=o.text;document.getElementById('fontFamily').value=o.fontFamily}document.getElementById('textEffects').style.display=o.type==='textbox'?'block':'none';const br=o.getBoundingRect(true,true);document.getElementById('objWidth').value=pxToCmX(br.width).toFixed(1);document.getElementById('objHeight').value=pxToCmY(br.height).toFixed(1);document.getElementById('objX').value=pxToCmX(br.left).toFixed(1);document.getElementById('objY').value=pxToCmY(br.top).toFixed(1);document.getElementById('objAngle').value=Math.round(o.angle||0);document.getElementById('angleValue').textContent=Math.round(o.angle||0)+'°';if(o.type==='textbox'){document.getElementById('strokeWidth').value=o.strokeWidth||0;document.getElementById('strokeValue').textContent=(o.strokeWidth||0)+' px';document.getElementById('strokeColor').value=normalizeHex(o.stroke||'#ffffff');const sh=o.shadow;document.getElementById('shadowBlur').value=sh?sh.blur||0:0;document.getElementById('shadowValue').textContent=(sh?sh.blur||0:0)+' px';document.getElementById('shadowColor').value=normalizeHex(sh&&sh.color?sh.color:'#000000')}updatePrintInfo();refreshLayers()}
function normalizeHex(c){if(/^#[0-9a-f]{6}$/i.test(c))return c;return '#000000'}

function setDimension(which,val){const o=canvas.getActiveObject();if(!o||!val)return;const br=o.getBoundingRect(true,true);if(which==='w'){const target=cmToPxX(val);o.scaleX*=target/br.width}else{const target=cmToPxY(val);o.scaleY*=target/br.height}o.setCoords();keepObjectInsideCanvas(o);canvas.renderAll();pushHistory();syncSelection()}
document.getElementById('objWidth').onchange=e=>setDimension('w',parseFloat(e.target.value));document.getElementById('objHeight').onchange=e=>setDimension('h',parseFloat(e.target.value));
document.getElementById('objX').onchange=e=>{const o=canvas.getActiveObject();if(!o)return;const br=o.getBoundingRect(true,true);o.left+=(cmToPxX(parseFloat(e.target.value))-br.left);o.setCoords();keepObjectInsideCanvas(o,{shrink:false});canvas.renderAll();pushHistory();syncSelection()};
document.getElementById('objY').onchange=e=>{const o=canvas.getActiveObject();if(!o)return;const br=o.getBoundingRect(true,true);o.top+=(cmToPxY(parseFloat(e.target.value))-br.top);o.setCoords();keepObjectInsideCanvas(o,{shrink:false});canvas.renderAll();pushHistory();syncSelection()};
document.getElementById('objAngle').oninput=e=>{const o=canvas.getActiveObject();if(!o)return;o.rotate(parseFloat(e.target.value));o.setCoords();canvas.renderAll();document.getElementById('angleValue').textContent=e.target.value+'°';updatePrintInfo()};document.getElementById('objAngle').onchange=pushHistory;
document.getElementById('strokeWidth').oninput=e=>{const o=canvas.getActiveObject();if(o&&o.type==='textbox'){o.set({strokeWidth:parseFloat(e.target.value),stroke:document.getElementById('strokeColor').value});canvas.renderAll();document.getElementById('strokeValue').textContent=e.target.value+' px'}};document.getElementById('strokeWidth').onchange=pushHistory;
document.getElementById('strokeColor').oninput=e=>{const o=canvas.getActiveObject();if(o&&o.type==='textbox'){o.set('stroke',e.target.value);canvas.renderAll()}};document.getElementById('strokeColor').onchange=pushHistory;
function applyShadow(){const o=canvas.getActiveObject();if(!o||o.type!=='textbox')return;const blur=parseInt(document.getElementById('shadowBlur').value)||0;o.set('shadow',blur?new fabric.Shadow({color:document.getElementById('shadowColor').value,blur,offsetX:Math.max(1,blur/3),offsetY:Math.max(1,blur/3)}):null);canvas.renderAll();document.getElementById('shadowValue').textContent=blur+' px'}
document.getElementById('shadowBlur').oninput=applyShadow;document.getElementById('shadowBlur').onchange=pushHistory;document.getElementById('shadowColor').oninput=applyShadow;document.getElementById('shadowColor').onchange=pushHistory;

function objectInside(o){
  if(!o)return false;
  o.setCoords();
  const r=o.getBoundingRect(true,true);
  const tolerance=2;
  return (
    r.left>=-tolerance &&
    r.top>=-tolerance &&
    r.left+r.width<=canvas.getWidth()+tolerance &&
    r.top+r.height<=canvas.getHeight()+tolerance
  );
}
function keepObjectInsideCanvas(o,{shrink=true}={}){
  if(!o)return;
  o.setCoords();
  let r=o.getBoundingRect(true,true);
  if(shrink && (r.width>canvas.getWidth() || r.height>canvas.getHeight())){
    const factor=Math.min(canvas.getWidth()/Math.max(r.width,1),canvas.getHeight()/Math.max(r.height,1));
    o.scaleX*=factor; o.scaleY*=factor;
    o.setCoords();
    r=o.getBoundingRect(true,true);
  }
  let dx=0,dy=0;
  if(r.left<0)dx=-r.left;
  if(r.top<0)dy=-r.top;
  if(r.left+r.width>canvas.getWidth())dx+=canvas.getWidth()-(r.left+r.width);
  if(r.top+r.height>canvas.getHeight())dy+=canvas.getHeight()-(r.top+r.height);
  if(dx||dy){o.left+=dx;o.top+=dy;o.setCoords();}
}
function updatePrintInfo(){const o=canvas.getActiveObject();const q=document.getElementById('qualityText'),badge=document.getElementById('dpiBadge');if(!o){document.getElementById('printPosition').textContent='–';document.getElementById('printSize').textContent='–';document.getElementById('dpiValue').textContent='–';badge.textContent='Noch kein Bild gewählt';badge.className='badge';q.textContent='Druckqualität wird geprüft';q.parentElement.style.color='var(--sc-good)';return}const r=o.getBoundingRect(true,true),w=pxToCmX(r.width),h=pxToCmY(r.height),x=pxToCmX(r.left),y=pxToCmY(r.top);document.getElementById('printPosition').textContent=`${x.toFixed(1)} / ${y.toFixed(1)} cm`;document.getElementById('printSize').textContent=`${w.toFixed(1)} × ${h.toFixed(1)} cm`;const inside=objectInside(o);if(!inside){badge.textContent='Ausserhalb Druckbereich';badge.className='badge bad';q.textContent='Motiv ausserhalb des Druckbereichs';q.parentElement.style.color='var(--sc-danger)'}if(o.type==='image'){if(o.isVector){document.getElementById('dpiValue').textContent='Vektor';if(inside){badge.textContent='Vektor · optimal';badge.className='badge';q.textContent='Vektorgrafik · sehr gut';q.parentElement.style.color='var(--sc-good)'}}else{const inch=w/2.54;const dpi=Math.round((o.sourcePxW||o.width)/Math.max(inch,.01));document.getElementById('dpiValue').textContent=dpi+' DPI';if(inside){if(dpi>=250){badge.textContent='Sehr gute Druckqualität';badge.className='badge';q.textContent=`${dpi} DPI · sehr gut`;q.parentElement.style.color='var(--sc-good)'}else if(dpi>=150){badge.textContent='Mittlere Druckqualität';badge.className='badge warn';q.textContent=`${dpi} DPI · mittel`;q.parentElement.style.color='#9a702d'}else{badge.textContent='Auflösung zu niedrig';badge.className='badge bad';q.textContent=`${dpi} DPI · niedrig`;q.parentElement.style.color='var(--sc-danger)'}}}}else{document.getElementById('dpiValue').textContent='Text/Vektor';if(inside){badge.textContent='Text · optimal';badge.className='badge';q.textContent='Textobjekt · sehr gut';q.parentElement.style.color='var(--sc-good)'}}}

canvas.on('selection:created',syncSelection);canvas.on('selection:updated',syncSelection);canvas.on('selection:cleared',syncSelection);
canvas.on('object:modified',e=>{keepObjectInsideCanvas(e.target);canvas.renderAll();pushHistory();syncSelection();calcPrice()});canvas.on('object:scaling',e=>{keepObjectInsideCanvas(e.target);updatePrintInfo()});canvas.on('object:rotating',e=>{keepObjectInsideCanvas(e.target);updatePrintInfo()});
canvas.on('object:moving',e=>{
  const o=e.target;
  if(!o)return;

  const c=o.getCenterPoint(),tol=7;
  let cx=c.x,cy=c.y;

  document.getElementById('guideV').style.display='none';
  document.getElementById('guideH').style.display='none';

  if(Math.abs(cx-canvas.getWidth()/2)<tol){
    cx=canvas.getWidth()/2;
    document.getElementById('guideV').style.display='block';
  }

  if(Math.abs(cy-canvas.getHeight()/2)<tol){
    cy=canvas.getHeight()/2;
    document.getElementById('guideH').style.display='block';
  }

  if(cx!==c.x||cy!==c.y){
    o.setPositionByOrigin(new fabric.Point(cx,cy),'center','center');
    o.setCoords();
  }

  keepObjectInsideCanvas(o,{shrink:false});
  updatePrintInfo();
  syncSelection();
});
canvas.on('mouse:up',()=>{document.getElementById('guideV').style.display='none';document.getElementById('guideH').style.display='none'});

function sideHasDesign(which){if(which===side)return canvas.getObjects().length>0;if(!states[which])return false;try{return JSON.parse(states[which]).objects.length>0}catch{return false}}
function quantityTier(qty){
 if(qty>=100)return '100-150';
 if(qty>=20)return '20-99';
 if(qty>=10)return '10-19';
 if(qty>=5)return '5-9';
 return '1-4';
}
const PRINT_PRICE={
 small:{label:'Klein · bis 10×10 cm',prices:{'1-4':9,'5-9':8,'10-19':7,'20-99':6,'100-150':5}},
 a5:{label:'Mittel · bis A5',prices:{'1-4':13,'5-9':11,'10-19':10,'20-99':9,'100-150':8}},
 a4:{label:'Gross · bis A4',prices:{'1-4':18,'5-9':16,'10-19':14,'20-99':12,'100-150':10}},
 a3:{label:'XL · bis A3 / grosser Druck',prices:{'1-4':27,'5-9':24,'10-19':21,'20-99':19,'100-150':17}}
};

function objectsForSide(whichSide){
 const state=states[whichSide] || (whichSide===side?serialize():null);
 if(!state)return [];
 try{return JSON.parse(state).objects||[]}catch{return []}
}
function dimsForObjects(objects,whichSide){
  if(!objects.length)return null;

  const prev=side,prevZone=activeQuickZone;
  side=whichSide;activeQuickZone=quickZones[whichSide]||'full';
  const area=getFullPrintArea();
  side=prev;activeQuickZone=prevZone;

  let l=Infinity,t=Infinity,r=-Infinity,b=-Infinity;

  objects.forEach(o=>{
    const hasProductionBounds=[
      o.productionXcm,
      o.productionYcm,
      o.productionWcm,
      o.productionHcm
    ].every(Number.isFinite);

    if(hasProductionBounds){
      l=Math.min(l,o.productionXcm);
      t=Math.min(t,o.productionYcm);
      r=Math.max(r,o.productionXcm+o.productionWcm);
      b=Math.max(b,o.productionYcm+o.productionHcm);
      return;
    }

    const w=(o.width||0)*Math.abs(o.scaleX??1);
    const h=(o.height||0)*Math.abs(o.scaleY??1);
    const x=o.left||0;
    const y=o.top||0;

    const ox=o.originX||'left';
    const oy=o.originY||'top';

    const left=ox==='center'?x-w/2:ox==='right'?x-w:x;
    const top=oy==='center'?y-h/2:oy==='bottom'?y-h:y;

    l=Math.min(l,left/canvas.getWidth()*area.w);
    r=Math.max(r,(left+w)/canvas.getWidth()*area.w);
    t=Math.min(t,top/canvas.getHeight()*area.h);
    b=Math.max(b,(top+h)/canvas.getHeight()*area.h);
  });

  return {
    w:Math.max(0,r-l),
    h:Math.max(0,b-t),
    x:l,
    y:t
  };
}
function printClass(dim){
 if(!dim)return null;
 if(dim.w<=10&&dim.h<=10)return 'small';
 if(dim.w<=15&&dim.h<=21)return 'a5';
 if(dim.w<=21&&dim.h<=30)return 'a4';
 return 'a3';
}
const SPECIAL_PRICE={
 leftSleeve:{label:'Ärmel links',prices:{'1-4':10,'5-9':9,'10-19':8,'20-99':7,'100-150':6}},
 rightSleeve:{label:'Ärmel rechts',prices:{'1-4':10,'5-9':9,'10-19':8,'20-99':7,'100-150':6}},
 neck:{label:'Nackenlogo',prices:{'1-4':8,'5-9':7,'10-19':6,'20-99':5,'100-150':4.5}},
 hem:{label:'Bunddruck',prices:{'1-4':8,'5-9':7,'10-19':6,'20-99':5,'100-150':4.5}}
};
function sidePriceBreakdown(whichSide,qty){
 const objs=objectsForSide(whichSide),tier=quantityTier(qty),rows=[];
 const standard=objs.filter(o=>!o.printPosition||o.printPosition==='standard');
 if(standard.length){
   const dim=dimsForObjects(standard,whichSide);
   if(isSleeveSurface(whichSide)){
     const sp=SPECIAL_PRICE[whichSide];
     rows.push({position:surfaceLabel(whichSide),price:sp.prices[tier],label:`${surfaceLabel(whichSide)} · ${dim.w.toFixed(1)}×${dim.h.toFixed(1)} cm`,widthCm:Number(dim.w.toFixed(1)),heightCm:Number(dim.h.toFixed(1)),xCm:Number(dim.x.toFixed(1)),yCm:Number(dim.y.toFixed(1))});
   }else{
     const cls=printClass(dim),p=PRINT_PRICE[cls];
     rows.push({position:surfaceLabel(whichSide),price:p.prices[tier],label:`${p.label} · ${dim.w.toFixed(1)}×${dim.h.toFixed(1)} cm`,widthCm:Number(dim.w.toFixed(1)),heightCm:Number(dim.h.toFixed(1)),xCm:Number(dim.x.toFixed(1)),yCm:Number(dim.y.toFixed(1))});
   }
 }
 if(!isSleeveSurface(whichSide)) for(const key of Object.keys(SPECIAL_PRICE)){
   const group=objs.filter(o=>o.printPosition===key);
   if(group.length){
     const sp=SPECIAL_PRICE[key],dim=dimsForObjects(group,whichSide);
     rows.push({position:sp.label,price:sp.prices[tier],label:`${sp.label} · ${dim.w.toFixed(1)}×${dim.h.toFixed(1)} cm`,widthCm:Number(dim.w.toFixed(1)),heightCm:Number(dim.h.toFixed(1)),xCm:Number(dim.x.toFixed(1)),yCm:Number(dim.y.toFixed(1))});
   }
 }
 return rows;
}
async function calcPrice(){
let base=currentProduct ? currentProduct.price : 0;

try {
  const shopifyProduct = currentProduct
    ? await loadShopifyProduct(currentProduct)
    : null;

  if (shopifyProduct && Number.isFinite(Number(shopifyProduct.price))) {
    base = Number(shopifyProduct.price) / 100;
  }
} catch (e) {
  console.warn(
    'Shopify-Preis konnte nicht geladen werden – hinterlegter Preis wird verwendet.',
    e
  );
}
 const realQty=[...document.querySelectorAll('.qty')].reduce((a,i)=>a+(parseInt(i.value)||0),0);
 const qty=Math.max(realQty,1);
 const frontRows=sidePriceBreakdown('front',qty),backRows=sidePriceBreakdown('back',qty);
 const leftSleeveRows=isJogger()?[]:sidePriceBreakdown('leftSleeve',qty);
 const rightSleeveRows=isJogger()?[]:sidePriceBreakdown('rightSleeve',qty);
 const front=frontRows.reduce((a,x)=>a+x.price,0),back=backRows.reduce((a,x)=>a+x.price,0);
 const sleeves=[...leftSleeveRows,...rightSleeveRows].reduce((a,x)=>a+x.price,0);
 const unit=base+front+back+sleeves;
 document.getElementById('basePrice').textContent=`CHF ${base.toFixed(2)}`;
 document.getElementById('frontPrice').textContent=`CHF ${(front+sleeves).toFixed(2)}`;
 document.getElementById('backPrice').textContent=`CHF ${back.toFixed(2)}`;
 document.getElementById('frontPrice').title=[...frontRows,...leftSleeveRows,...rightSleeveRows].map(x=>`${x.position}: CHF ${x.price.toFixed(2)} (${x.label})`).join('\n')||'Kein Druck';
 document.getElementById('backPrice').title=backRows.map(x=>`${x.position}: CHF ${x.price.toFixed(2)} (${x.label})`).join('\n')||'Kein Druck';
 document.getElementById('qtyTotal').textContent=realQty||1;
 document.getElementById('totalPrice').textContent=`CHF ${(unit*qty).toFixed(2)}`;
}
function applyProduct(){currentProduct=UM_PRODUCTS.find(p=>p.id===document.getElementById('productSelect').value)||UM_PRODUCTS[0];if(isJogger()&&isSleeveSurface()){side='front';activeQuickZone=quickZones.front||'full';canvas.clear();}currentColor=currentProduct.colors.find(c=>c.code==='100')||currentProduct.colors[0];shirtColor=currentColor.code;renderColors();renderSizes();renderProductMeta();document.querySelector('.stage-head .tiny').textContent=currentProduct.name;refreshSurfaceLabels();document.getElementById('sideTitle').textContent=surfaceLabel(side)+' gestalten';renderQuickPositions();applyPrintArea();updateProductPhoto();calcPrice();setTimeout(refreshShopifyStatus,50)}
function basePrintAreaForSurface(whichSide=side,zone=activeQuickZone){
  if(currentProduct.kind==='jogger'){
    return whichSide==='front'
      ? {w:12,h:70,css:{width:'14%',height:'64%',left:'35%',top:'25%'}}
      : {w:12,h:70,css:{width:'14%',height:'64%',left:'51%',top:'25%'}};
  }
  if(isSleeveSurface(whichSide)){
    const outer=currentProduct.kind==='hoodie'||currentProduct.kind==='fullzip'||currentProduct.kind==='crewneck';
    const polo=currentProduct.kind==='polo';
    const left=whichSide==='leftSleeve'?(outer?'75%':(polo?'72%':'71%')):(outer?'15%':(polo?'18%':'17%'));
    const top=outer?'31%':(polo?'29%':'28%');
    const width=outer?'10%':'12%';
    const height=outer?'17%':'13%';
    return {w:10,h:12,css:{width,height,left,top}};
  }
  if(whichSide==='front' && (zone==='chestLeft' || zone==='chestRight')){
    let top='28%', width='12%', height='11%';
    if(currentProduct.kind==='hoodie' || currentProduct.kind==='fullzip'){top='31%';width='11%';height='9%';}
    else if(currentProduct.kind==='polo'){top='29%';}
    const left=zone==='chestLeft'?'53%':'35%';
    return {w:8,h:9,css:{width,height,left,top}};
  }
  const w=currentProduct.print.w;
  if(whichSide==='back'){
    const extra=currentProduct.kind==='tshirt'?10:currentProduct.kind==='crewneck'?9:currentProduct.kind==='polo'?8:8;
    const h=currentProduct.print.h+extra;
    return {w,h,css:{width:currentProduct.kind==='polo'||currentProduct.kind==='fullzip'?'42%':'44%',height:currentProduct.kind==='tshirt'?'57%':'50%',left:currentProduct.kind==='polo'||currentProduct.kind==='fullzip'?'29%':'28%',top:currentProduct.kind==='tshirt'?'22%':'27%'}};
  }
  if(currentProduct.kind==='hoodie'||currentProduct.kind==='fullzip') return {w,h:currentProduct.print.h,css:{width:'42%',height:'36%',left:'29%',top:'34%'}};
  return {w,h:currentProduct.print.h,css:{width:'44%',height:'47%',left:'28%',top:'24%'}};
}
function areaForGarmentSize(size,whichSide=side,zone=activeQuickZone){
  const base=basePrintAreaForSurface(whichSide,zone);
  if(isSleeveSurface(whichSide)){
    const a=sleeveAreaForSize(size);
    return {...base,w:a.w,h:a.h};
  }
  if(currentProduct.kind==='jogger'){
    const factor=Math.min(1.08,Math.max(.78,sizeScaleFor(size)));
    return {...base,w:+(base.w*factor).toFixed(2),h:+(base.h*factor).toFixed(2)};
  }
  const factor=sizeScaleFor(size);
  if(whichSide==='front' && (zone==='chestLeft'||zone==='chestRight')){
    return {...base,w:+Math.min(8,base.w*factor).toFixed(2),h:+Math.min(9,base.h*factor).toFixed(2)};
  }
  const safe=SIZE_SAFE_WIDTH_CM[size]||base.w;
  const w=Math.min(base.w*factor,safe);
  const h=base.h*(w/base.w);
  return {...base,w:+w.toFixed(2),h:+h.toFixed(2)};
}
function liveCssForGarmentSize(area,size,whichSide=side,zone=activeQuickZone){
  const base=basePrintAreaForSurface(whichSide,zone);
  const css={...(base.css||{})};
  if(!css.width||!css.height||!css.left||!css.top)return css;

  // Brustlogos bleiben optisch an ihrer festen Brustposition; nur die realen cm werden kleiner.
  if(whichSide==='front'&&(zone==='chestLeft'||zone==='chestRight'))return css;

  const pct=v=>parseFloat(String(v).replace('%',''));
  const w0=pct(css.width),h0=pct(css.height),l0=pct(css.left),t0=pct(css.top);
  const centerX=l0+w0/2,centerY=t0+h0/2;
  const widthFactor=area.w/Math.max(base.w,.01);
  const heightFactor=area.h/Math.max(base.h,.01);
  const w=Math.max(4,w0*widthFactor),h=Math.max(4,h0*heightFactor);
  return {
    ...css,
    width:w.toFixed(2)+'%',height:h.toFixed(2)+'%',
    left:(centerX-w/2).toFixed(2)+'%',top:(centerY-h/2).toFixed(2)+'%'
  };
}
function getFullPrintArea(){
  const size=smallestOrderedSize();
  const a=areaForGarmentSize(size,side,activeQuickZone);
  return {...a,css:liveCssForGarmentSize(a,size,side,activeQuickZone)};
}
function renderQuickPositions(){
  const sel=document.getElementById('printAreaSelect');
  let opts;
  if(isJogger()){
    opts=[[side==='front'?'leftLeg':'rightLeg',surfaceLabel(side)]];
  }else if(isSleeveSurface()){
    const a=sleeveAreaForSize(smallestOrderedSize());
    opts=[['sleeve',`${surfaceLabel(side)} · max. ${a.w} × ${a.h} cm`]];
  }else{
    opts=side==='back'?
      [['full','Rücken komplett · frei bis zum Bund'],['upper','Rücken oben'],['center','Rücken mittig'],['hem','Rücken unten am Bund']]:
      [['full','Vorne komplett'],['chestLeft','Brust links · max. 8 × 9 cm'],['chestRight','Brust rechts · max. 8 × 9 cm'],['center','Vorne mittig']];
  }
  sel.innerHTML=opts.map(([v,l])=>`<option value="${v}">${l}</option>`).join('');
  if(!opts.some(x=>x[0]===activeQuickZone)) activeQuickZone=opts[0][0];
  sel.value=activeQuickZone;
}
function applyPrintArea(){
  if(!currentProduct)return;
  activeQuickZone=document.getElementById('printAreaSelect').value||'full';
  quickZones[side]=activeQuickZone;
  const a=getFullPrintArea();
  PRINT_W_CM=a.w;PRINT_H_CM=a.h;
  Object.assign(box.style,a.css);
  document.getElementById('areaDimensions').textContent=`${a.w} × ${a.h} cm`;
  box.setAttribute('data-area',side+'-'+activeQuickZone);
  const hg=document.getElementById('hemGuide');
  hg.style.display=!isJogger()&&side==='back'?'block':'none';
  const zg=document.getElementById('zoneGuide');
  const zl=document.getElementById('zoneGuideLabel');
  zg.style.display='none';
  if(!isJogger()&&!isSleeveSurface()&&activeQuickZone!=='full'&&activeQuickZone!=='chestLeft'&&activeQuickZone!=='chestRight'){
    zg.style.display='block';
    if(side==='back'&&activeQuickZone==='upper'){zg.style.top='4%';zg.style.height='34%';zl.textContent='Rücken oben'}
    else if(side==='back'&&activeQuickZone==='center'){zg.style.top='31%';zg.style.height='34%';zl.textContent='Rücken mittig'}
    else if(side==='back'&&activeQuickZone==='hem'){zg.style.top='79%';zg.style.height='20%';zl.textContent='Unten am Bund'}
    else if(side==='front'&&activeQuickZone==='center'){zg.style.top='28%';zg.style.height='38%';zl.textContent='Vorne mittig'}
  }
  sizeCanvas();updatePrintInfo();
}
function quickPositionActive(){
  const o=canvas.getActiveObject();
  if(!o||activeQuickZone==='full'||activeQuickZone==='sleeve'||isJogger())return;

  let cx=canvas.getWidth()/2,cy=canvas.getHeight()/2;

  if(side==='back'&&activeQuickZone==='upper')cy=canvas.getHeight()*.21;
  if(side==='back'&&activeQuickZone==='center')cy=canvas.getHeight()*.48;
  if(side==='back'&&activeQuickZone==='hem')cy=canvas.getHeight()*.89;

  if(side==='front'&&(activeQuickZone==='chestLeft'||activeQuickZone==='chestRight')){
    cx=canvas.getWidth()/2;
    cy=canvas.getHeight()/2;
  }

  if(side==='front'&&activeQuickZone==='center')cy=canvas.getHeight()*.47;

  o.setPositionByOrigin(
    new fabric.Point(cx,cy),
    'center',
    'center'
  );

  o.setCoords();
  canvas.renderAll();
  pushHistory();
  syncSelection();
}
document.getElementById('productSelect').onchange=applyProduct;document.getElementById('printAreaSelect').onchange=()=>{applyPrintArea();quickPositionActive()};

function exportDesign(){saveSide();const payload={version:11,collection:'Untagged Movement',productId:currentProduct.id,productHandle:currentProduct.handle,product:currentProduct.name,productBase:currentProduct.price,color:{code:currentColor.code,name:currentColor.name},printAreaCm:{width:PRINT_W_CM,height:PRINT_H_CM},quickPositions:{...quickZones},front:states.front,back:states.back,leftSleeve:states.leftSleeve,rightSleeve:states.rightSleeve,surfaces:{front:surfaceLabel('front'),back:surfaceLabel('back'),leftSleeve:'Ärmel links',rightSleeve:'Ärmel rechts'},quantities:Object.fromEntries([...document.querySelectorAll('.qty')].map(i=>[i.dataset.size,parseInt(i.value)||0])),createdAt:new Date().toISOString()};const blob=new Blob([JSON.stringify(payload,null,2)],{type:'application/json'});const a=document.createElement('a');a.href=URL.createObjectURL(blob);a.download='swiss-crafting-untagged-design-v8.json';a.click();setTimeout(()=>URL.revokeObjectURL(a.href),1000)}

function orderedSizes(){
  return [...document.querySelectorAll('.qty')]
    .map(i=>({size:i.dataset.size,qty:parseInt(i.value)||0}))
    .filter(x=>x.qty>0);
}
function smallestOrderedSize(){
  const s=orderedSizes().map(x=>x.size).sort((a,b)=>SIZE_ORDER.indexOf(a)-SIZE_ORDER.indexOf(b));
  return s[0]||'M';
}
function getAreaForSide(whichSide){
  const previous=side,previousZone=activeQuickZone;
  side=whichSide;activeQuickZone=quickZones[whichSide]||'full';
  const a=getFullPrintArea();
  side=previous;activeQuickZone=previousZone;
  return {w:a.w,h:a.h};
}
function sizeScaleFor(size){
  const ref=SIZE_CHEST_CM.M;
  return (SIZE_CHEST_CM[size]||ref)/ref;
}
function sleeveAreaForSize(size){
  const map={XXS:{w:7,h:8},XS:{w:8,h:9},S:{w:9,h:10},M:{w:10,h:11},L:{w:10,h:12},XL:{w:10,h:12},XXL:{w:10,h:12},'3XL':{w:10,h:12},'4XL':{w:10,h:12},'5XL':{w:10,h:12}};
  return map[size]||map.M;
}
function productionAreaFor(size,whichSide){
  const zone=quickZones[whichSide]||'full';
  const a=areaForGarmentSize(size,whichSide,zone);
  return {w:a.w,h:a.h,scale:a.w/Math.max(basePrintAreaForSurface(whichSide,zone).w,.01)};
}
function updateProductionStatus(){
  const ref=smallestOrderedSize();
  const el=document.getElementById('referenceSize'); if(el) el.textContent=ref;
  const count=document.getElementById('originalCount'); if(count) count.textContent=originalUploads.size;
  const badge=document.getElementById('productionBadge');
  if(!badge)return;
  const sizes=orderedSizes();
  if(!sizes.length){badge.textContent='Mindestens eine Grösse wählen';badge.className='badge warn';return}
  badge.textContent=`${sizes.length} Grössen · Produktionspaket bereit`;badge.className='badge';
}
function safeFileName(s){
  return String(s||'datei').normalize('NFKD').replace(/[^\w.-]+/g,'-').replace(/-+/g,'-').replace(/^-|-$/g,'');
}
function dataUrlToBase64(dataURL){return dataURL.split(',')[1]}
function stateFor(whichSide){
  if(whichSide===side) states[whichSide]=serialize();
  return states[whichSide];
}
function objectMetricsFromJSON(stateJson, areaCm){
  if(!stateJson)return [];

  const data=JSON.parse(stateJson);

  return (data.objects||[]).map((o,idx)=>{
    let xCm,yCm,wCm,hCm;

    const hasProductionBounds=[
      o.productionXcm,
      o.productionYcm,
      o.productionWcm,
      o.productionHcm
    ].every(Number.isFinite);

    if(hasProductionBounds){
      xCm=o.productionXcm;
      yCm=o.productionYcm;
      wCm=o.productionWcm;
      hCm=o.productionHcm;
    }else{
      const sx=Math.abs(o.scaleX??1);
      const sy=Math.abs(o.scaleY??1);

      const widthPx=(o.width||0)*sx;
      const heightPx=(o.height||0)*sy;

      const leftRaw=o.left||0;
      const topRaw=o.top||0;

      const originX=o.originX||'left';
      const originY=o.originY||'top';

      const leftPx=
        originX==='center'?leftRaw-widthPx/2:
        originX==='right'?leftRaw-widthPx:
        leftRaw;

      const topPx=
        originY==='center'?topRaw-heightPx/2:
        originY==='bottom'?topRaw-heightPx:
        topRaw;

      wCm=widthPx/Math.max(canvas.getWidth(),1)*areaCm.w;
      hCm=heightPx/Math.max(canvas.getHeight(),1)*areaCm.h;
      xCm=leftPx/Math.max(canvas.getWidth(),1)*areaCm.w;
      yCm=topPx/Math.max(canvas.getHeight(),1)*areaCm.h;
    }

    let effectiveDpi=null;

    if(o.type==='image'&&!o.isVector&&o.sourcePxW&&wCm>0){
      effectiveDpi=Math.round(o.sourcePxW/(wCm/2.54));
    }

    return {
      index:idx+1,
      type:o.type,
      name:o.name||o.originalName||`${o.type}-${idx+1}`,
      xCm:+xCm.toFixed(2),
      yCm:+yCm.toFixed(2),
      widthCm:+wCm.toFixed(2),
      heightCm:+hCm.toFixed(2),
      rotationDeg:+(o.angle||0).toFixed(1),
      printPosition:o.printPosition||'standard',
      isVector:!!o.isVector,
      effectiveDpi,
      uploadId:o.uploadId||null
    };
  });
}
async function renderState300Dpi(stateJson, areaCm){
  if(!stateJson)return null;
  const tmpEl=document.createElement('canvas');
  const tmp=new fabric.StaticCanvas(tmpEl,{width:canvas.getWidth(),height:canvas.getHeight(),backgroundColor:null});
  await new Promise(resolve=>tmp.loadFromJSON(stateJson,()=>{tmp.renderAll();resolve()}));
  if(!tmp.getObjects().length){tmp.dispose();return null}

  const bounds=tmp.getObjects().reduce((acc,o)=>{
    const r=o.getBoundingRect(true,true);
    acc.left=Math.min(acc.left,r.left);acc.top=Math.min(acc.top,r.top);
    acc.right=Math.max(acc.right,r.left+r.width);acc.bottom=Math.max(acc.bottom,r.top+r.height);
    return acc;
  },{left:Infinity,top:Infinity,right:-Infinity,bottom:-Infinity});

  bounds.left=Math.max(0,bounds.left);bounds.top=Math.max(0,bounds.top);
  bounds.right=Math.min(tmp.getWidth(),bounds.right);bounds.bottom=Math.min(tmp.getHeight(),bounds.bottom);
  const cropW=Math.max(1,bounds.right-bounds.left),cropH=Math.max(1,bounds.bottom-bounds.top);

  const physicalWcm=cropW/tmp.getWidth()*areaCm.w;
  const physicalHcm=cropH/tmp.getHeight()*areaCm.h;
  const targetPxW=Math.max(1,Math.round(physicalWcm/2.54*300));
  const multiplier=targetPxW/cropW;

  const dataURL=tmp.toDataURL({
    format:'png',left:bounds.left,top:bounds.top,width:cropW,height:cropH,
    multiplier,enableRetinaScaling:false
  });
  tmp.dispose();
  return {
    dataURL,
    widthCm:+physicalWcm.toFixed(2),heightCm:+physicalHcm.toFixed(2),
    pixelWidth:targetPxW,pixelHeight:Math.round(cropH*multiplier),
    crop:{left:bounds.left,top:bounds.top,width:cropW,height:cropH}
  };
}
async function exportProductionPackage(){
  if(typeof JSZip==='undefined'){alert('ZIP-Bibliothek konnte nicht geladen werden. Bitte Internetverbindung prüfen.');return}
  saveSide();
  const sizes=orderedSizes();
  if(!sizes.length){alert('Bitte mindestens eine Kleidergrösse und Menge auswählen.');return}

  const btn=document.getElementById('productionBtn');
  const old=btn.textContent;btn.disabled=true;btn.textContent='Produktionspaket wird erstellt …';

  try{
    const zip=new JSZip();
    const stamp=new Date().toISOString().replace(/[:.]/g,'-');
    const draftId='SC-DRAFT-'+stamp.slice(0,19);
    const manifest={
      schema:'swiss-crafting-production-v1',
      configuratorVersion:11,
      draftId,
      createdAt:new Date().toISOString(),
      collection:'Untagged Movement',
      product:{id:currentProduct.id,handle:currentProduct.handle,name:currentProduct.name,basePriceCHF:currentProduct.price},
      color:{code:currentColor.code,name:currentColor.name},
      quantities:Object.fromEntries(sizes.map(x=>[x.size,x.qty])),
      output:{format:'PNG',dpi:300,background:'transparent',mode:'artwork-only'},
      sizingRule:'Artwork scales proportionally with garment size. Each ordered size receives its own physical print dimensions; product and safe-width limits are respected.',
      sides:{}
    };

    // Originals
    for(const [id,file] of originalUploads.entries()){
      const safe=safeFileName(file.name)||id;
      zip.file(`01_ORIGINALE/${id}_${safe}`,file);
    }

    for(const whichSide of activeSurfaceKeys()){
      const state=stateFor(whichSide);
      if(!state)continue;
      let parsed;try{parsed=JSON.parse(state)}catch{continue}
      if(!(parsed.objects||[]).length)continue;
      manifest.sides[whichSide]={sizes:{}};

      for(const entry of sizes){
        const area=productionAreaFor(entry.size,whichSide);
        const result=await renderState300Dpi(state,area);
        if(!result)continue;
        const sideLabel=isJogger()?(whichSide==='front'?'HOSENBEIN_LINKS':'HOSENBEIN_RECHTS'):(whichSide==='front'?'VORDERSEITE':whichSide==='back'?'RUECKSEITE':whichSide==='leftSleeve'?'AERMEL_LINKS':'AERMEL_RECHTS');
        const base=`02_DRUCKDATEIEN/${sideLabel}/${entry.size}`;
        const name=`${draftId}_${currentProduct.id}_${currentColor.code}_${entry.size}_${sideLabel}_${result.widthCm}x${result.heightCm}cm_300dpi.png`;
        zip.file(`${base}/${safeFileName(name)}`,dataUrlToBase64(result.dataURL),{base64:true});

        const objects=objectMetricsFromJSON(state,area);
        manifest.sides[whichSide].sizes[entry.size]={
          quantity:entry.qty,
          printAreaCm:{width:+area.w.toFixed(2),height:+area.h.toFixed(2)},
          artworkCm:{width:result.widthCm,height:result.heightCm},
          pixels:{width:result.pixelWidth,height:result.pixelHeight},
          objects
        };
      }
    }

    const design={
      version:11,draftId,
      productId:currentProduct.id,productHandle:currentProduct.handle,
      color:{code:currentColor.code,name:currentColor.name},
      quantities:Object.fromEntries(sizes.map(x=>[x.size,x.qty])),
      front:states.front,back:states.back,leftSleeve:states.leftSleeve,rightSleeve:states.rightSleeve,quickPositions:{...quickZones},surfaces:{front:surfaceLabel('front'),back:surfaceLabel('back'),leftSleeve:'Ärmel links',rightSleeve:'Ärmel rechts'}
    };
    zip.file('03_DESIGN/design.json',JSON.stringify(design,null,2));
    zip.file('04_PRODUKTION/production_manifest.json',JSON.stringify(manifest,null,2));
    zip.file('04_PRODUKTION/README.txt',
`SWISS-CRAFTING PRODUKTIONSPAKET
Entwurf: ${draftId}
Produkt: ${currentProduct.name}
Farbe: ${currentColor.name} (${currentColor.code})

INHALT
01_ORIGINALE = unveränderte Kundendateien
02_DRUCKDATEIEN = transparente 300-DPI-PNGs je Kleidergrösse und Druckseite
03_DESIGN = editierbare Konfigurator-Daten
04_PRODUKTION = exakte Masse, Positionen, Mengen und Qualitätsdaten

WICHTIG
Eine 300-DPI-Ausgabedatei kann fehlende Bildinformationen einer zu kleinen Rastervorlage nicht ersetzen.
Prüfe im production_manifest.json den Wert effectiveDpi der Rasterbilder.
SVG-Dateien bleiben als Original erhalten und sind für die Produktion zu bevorzugen.`);

    const blob=await zip.generateAsync({type:'blob',compression:'DEFLATE',compressionOptions:{level:6}});
    const a=document.createElement('a');
    const url=URL.createObjectURL(blob);
    a.href=url;a.download=`${draftId}_${safeFileName(currentProduct.name)}_PRODUKTION.zip`;a.click();
    setTimeout(()=>URL.revokeObjectURL(url),2000);
  }catch(err){
    console.error(err);alert('Produktionspaket konnte nicht erstellt werden: '+err.message);
  }finally{
    btn.disabled=false;btn.textContent=old;
  }
}


// ===== Swiss-Crafting V11 Shopify integration =====
// When this configurator is hosted on swiss-crafting.ch, relative Shopify endpoints
// automatically use the live shop and return current variant IDs.
const SHOPIFY_INTEGRATION = {
  shopOrigin: window.SC_CONFIGURATOR_SETTINGS?.shopOrigin || 'https://www.swiss-crafting.ch',
  serviceProductHandle: window.SC_CONFIGURATOR_SETTINGS?.serviceProductHandle || 'druckservice-konfigurator',
  productionUploadEndpoint: window.SC_CONFIGURATOR_SETTINGS?.productionUploadEndpoint || null
};
const PRINT_SERVICE_OPTION = {
  small:'Klein 10x10', a5:'A5', a4:'A4', a3:'A3',
  sleeve:'Ärmel', neck:'Nacken', hem:'Bund'
};
let printServiceMap = new Map();
let printServiceLoaded = false;
let printServiceLoading = null;

let shopifyProductCache=new Map();
let currentDesignId='';

function newDesignId(){
  const d=new Date();
  return 'SC-'+d.getFullYear()+String(d.getMonth()+1).padStart(2,'0')+String(d.getDate()).padStart(2,'0')+
    '-'+Math.random().toString(36).slice(2,8).toUpperCase();
}
function ensureDesignId(){
  if(!currentDesignId) currentDesignId=newDesignId();
  const el=document.getElementById('shopifyDesignId');if(el)el.textContent=currentDesignId;
  return currentDesignId;
}
function shopUrl(path){
  // Relative URL in live Shopify theme; fixed origin in local prototype.
  return location.hostname.endsWith('swiss-crafting.ch') ? path : SHOPIFY_INTEGRATION.shopOrigin+path;
}
async function loadPrintServiceMap(){
  if(printServiceLoaded)return printServiceMap;
  if(printServiceLoading)return printServiceLoading;
  printServiceLoading=(async()=>{
    const handle=SHOPIFY_INTEGRATION.serviceProductHandle;
    const res=await fetch(shopUrl(`/products/${handle}.js`),{credentials:'same-origin'});
    if(!res.ok)throw new Error(`Druckservice-Produkt nicht erreichbar (${res.status}). Handle: ${handle}`);
    const product=await res.json();
    const map=new Map();
    for(const v of (product.variants||[])){
      const opts=[v.option1,v.option2,v.option3].filter(Boolean).map(x=>String(x).trim());
      const title=String(v.title||'');
      for(const [key,label] of Object.entries(PRINT_SERVICE_OPTION)){
        const hasLabel=opts.includes(label)||title.includes(label);
        if(!hasLabel)continue;
        for(const tier of ['1-4','5-9','10-19','20-99','100-150']){
          if(opts.includes(tier)||title.includes(tier)) map.set(`${key}|${tier}`,Number(v.id));
        }
      }
    }
    printServiceMap=map; printServiceLoaded=true;
    return map;
  })().catch(err=>{printServiceLoading=null;throw err});
  return printServiceLoading;
}

async function loadShopifyProduct(product=currentProduct){
  if(!product)return null;
  if(shopifyProductCache.has(product.handle))return shopifyProductCache.get(product.handle);
  const url=shopUrl(`/products/${product.handle}.js`);
  const res=await fetch(url,{credentials:'omit'});
  if(!res.ok)throw new Error(`Shopify Produktdaten ${res.status}`);
  const data=await res.json();
  shopifyProductCache.set(product.handle,data);
  return data;
}
function norm(s){return String(s??'').trim().toLowerCase().replace(/ß/g,'ss').replace(/\s+/g,' ')}
function sizeAliases(size){
  const s=norm(size);
  const aliases=new Set([s]);
  if(s==='xxl')aliases.add('2xl');
  if(s==='2xl')aliases.add('xxl');
  if(s==='xxxl')aliases.add('3xl');
  return aliases;
}
function colorCandidates(c){
  if(!c)return [];
  return [...new Set([c.name,c.code,`${c.name} (${c.code})`,`${c.name} ${c.code}`].map(norm))];
}
function variantMatches(v,size,color){
  const sizes=sizeAliases(size);
  const sizeOK=sizes.has(norm(v.option2));

  const colors=colorCandidates(color);
  const shopifyColor=norm(v.option1);

  const colorOK=colors.some(c =>
    shopifyColor===c ||
    shopifyColor.includes(c) ||
    c.includes(shopifyColor)
  );

  return sizeOK && colorOK;
}
async function resolveVariant(size){
  const product=await loadShopifyProduct();
  const variants=product?.variants||[];
  let v=variants.find(v=>variantMatches(v,size,currentColor));
  if(!v){
    // More conservative second pass: exact size plus color code.
    const sz=[...sizeAliases(size)];
    v=variants.find(x=>{
      const txt=norm(`${x.title} ${x.option1||''} ${x.option2||''} ${x.option3||''}`);
      return sz.some(s=>txt.split(/[\/,\- ]+/).includes(s)) && txt.includes(norm(currentColor.code));
    });
  }
  return v||null;
}
async function refreshShopifyStatus(){
  ensureDesignId();
  const el=document.getElementById('shopifyVariantStatus');
  if(!el)return;
  el.textContent='werden geladen …';
  try{
    const product=await loadShopifyProduct();
    const ordered=orderedSizes();
    if(!ordered.length){el.textContent=`${product.variants?.length||0} Varianten gefunden`;return}
    let ok=0;
    for(const x of ordered){if(await resolveVariant(x.size))ok++}
    el.textContent=`${ok}/${ordered.length} bestellte Grössen erkannt`;
  }catch(e){
    el.textContent='lokal nicht erreichbar';
    el.title=e.message;
  }
  updatePrintChargeStatus();
}
function printChargeRequirements(qty){
  const tier=quantityTier(qty), req=[];
  for(const whichSide of activeSurfaceKeys()){
    const objs=objectsForSide(whichSide);
    const standard=objs.filter(o=>!o.printPosition||o.printPosition==='standard');
    if(standard.length){
      if(isSleeveSurface(whichSide)){req.push({key:'sleeve',tier,label:surfaceLabel(whichSide)});}
      else{const cls=printClass(dimsForObjects(standard,whichSide));req.push({key:cls,tier,label:`${surfaceLabel(whichSide)} ${PRINT_PRICE[cls].label}`});}
    }
    if(!isSleeveSurface(whichSide)) for(const [key,sp] of Object.entries(SPECIAL_PRICE)){
      if(objs.some(o=>o.printPosition===key)){
        req.push({key:key==='leftSleeve'||key==='rightSleeve'?'sleeve':key,tier,label:sp.label});
      }
    }
  }
  return req;
}
async function updatePrintChargeStatus(){
  const qty=Math.max(1,orderedSizes().reduce((a,x)=>a+x.qty,0));
  const req=printChargeRequirements(qty);
  const el=document.getElementById('shopifyPrintStatus');
  if(!el)return;
  if(!req.length){el.textContent='kein Druck';return}
  try{
    el.textContent='Servicevarianten werden geladen …';
    await loadPrintServiceMap();
    const configured=req.filter(r=>serviceVariantFor(r)).length;
    el.textContent=configured===req.length ? `${configured}/${req.length} automatisch erkannt` : `${configured}/${req.length} Varianten gefunden`;
  }catch(e){el.textContent='Druckservice nicht eingerichtet';el.title=e.message}
}

function designSummary(){
  saveSide();

  const qty=orderedSizes();
  const totalQty=qty.reduce((a,x)=>a+x.qty,0);

  const front=sidePriceBreakdown('front',Math.max(1,totalQty));
  const back=sidePriceBreakdown('back',Math.max(1,totalQty));
  const leftSleeve=isJogger()?[]:sidePriceBreakdown('leftSleeve',Math.max(1,totalQty));
  const rightSleeve=isJogger()?[]:sidePriceBreakdown('rightSleeve',Math.max(1,totalQty));

  return {
    designId:ensureDesignId(),
    product:currentProduct.name,
    productId:currentProduct.id,
    handle:currentProduct.handle,
    color:`${currentColor.name} (${currentColor.code})`,
    quantities:qty,
    printAreas:{front:getAreaForSide('front'),back:getAreaForSide('back'),leftSleeve:isJogger()?null:getAreaForSide('leftSleeve'),rightSleeve:isJogger()?null:getAreaForSide('rightSleeve')},
    quickPositions:{...quickZones},
    surfaces:{front:surfaceLabel('front'),back:surfaceLabel('back'),leftSleeve:'Ärmel links',rightSleeve:'Ärmel rechts'},
    front,
    back,
    leftSleeve,
    rightSleeve,
    configuratorVersion:11
  };
}

async function loadPreviewImage(src){
  return await new Promise((resolve,reject)=>{
    const img=new Image();
    img.crossOrigin='anonymous';
    img.onload=()=>resolve(img);
    img.onerror=()=>reject(new Error('Produktbild konnte für die Vorschau nicht geladen werden.'));
    img.src=src;
  });
}

function drawContainedImage(ctx,img,x,y,w,h){
  const iw=img.naturalWidth||img.width||1;
  const ih=img.naturalHeight||img.height||1;
  const scale=Math.min(w/iw,h/ih);
  const dw=iw*scale,dh=ih*scale;
  const dx=x+(w-dw)/2,dy=y+(h-dh)/2;
  ctx.drawImage(img,dx,dy,dw,dh);
}

function printAreaForSide(whichSide){
  const previous=side,previousZone=activeQuickZone;
  side=whichSide;activeQuickZone=quickZones[whichSide]||'full';
  const area=getFullPrintArea();
  side=previous;activeQuickZone=previousZone;
  return area;
}

async function renderCustomerPreview(whichSide,stateJson){
  if(!stateJson)return null;
  let parsed;
  try{parsed=JSON.parse(stateJson)}catch{return null}
  if(!(parsed.objects||[]).length)return null;

  const size=1200;
  const out=document.createElement('canvas');
  out.width=size;
  out.height=size;
  const ctx=out.getContext('2d');
  ctx.clearRect(0,0,size,size);

  const garment=await loadPreviewImage(productImageUrl(currentProduct,currentColor,whichSide));
  drawContainedImage(ctx,garment,0,0,size,size);

  const tmpEl=document.createElement('canvas');
  const sourceW=Math.max(1,canvas.getWidth());
  const sourceH=Math.max(1,canvas.getHeight());
  const tmp=new fabric.StaticCanvas(tmpEl,{width:sourceW,height:sourceH,backgroundColor:null});
  await new Promise(resolve=>tmp.loadFromJSON(stateJson,()=>{tmp.renderAll();resolve()}));

  const area=printAreaForSide(whichSide);
  const pct=n=>parseFloat(String(n||'0').replace('%',''))/100;
  const targetX=pct(area.css.left)*size;
  const targetY=pct(area.css.top)*size;
  const targetW=pct(area.css.width)*size;
  const targetH=pct(area.css.height)*size;

  ctx.drawImage(tmp.lowerCanvasEl,0,0,sourceW,sourceH,targetX,targetY,targetW,targetH);
  tmp.dispose();

  return out.toDataURL('image/png');
}

async function createCustomerPreviews(){
  saveSide();
  const frontState=states.front,backState=states.back,leftSleeveState=states.leftSleeve,rightSleeveState=states.rightSleeve;
  const [frontPreview,backPreview,leftSleevePreview,rightSleevePreview]=await Promise.all([
    renderCustomerPreview('front',frontState),renderCustomerPreview('back',backState),
    isJogger()?null:renderCustomerPreview('leftSleeve',leftSleeveState),
    isJogger()?null:renderCustomerPreview('rightSleeve',rightSleeveState)
  ]);
  return {frontPreview,backPreview,leftSleevePreview,rightSleevePreview};
}

async function persistDesignForOrder(){
  const summary=designSummary();
  const frontState=states.front;
  const backState=states.back;
  const leftSleeveState=states.leftSleeve;
  const rightSleeveState=states.rightSleeve;
  const previews=await createCustomerPreviews();

  if(!SHOPIFY_INTEGRATION.productionUploadEndpoint){
    if(location.hostname.endsWith('swiss-crafting.ch')) throw new Error('Der Konfigurator ist eingebaut, aber der Produktionsspeicher ist noch nicht verbunden. Checkout wird zum Schutz vor verlorenen Druckdaten blockiert.');
    return {designId:summary.designId,productionUrl:'local-prototype'};
  }

  const res=await fetch(SHOPIFY_INTEGRATION.productionUploadEndpoint,{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({
      designId:summary.designId,
      summary,
      front:frontState,
      back:backState,
      leftSleeve:leftSleeveState,
      rightSleeve:rightSleeveState,
      customerPreviewFront:previews.frontPreview,
      customerPreviewBack:previews.backPreview,
      customerPreviewLeftSleeve:previews.leftSleevePreview,
      customerPreviewRightSleeve:previews.rightSleevePreview
    })
  });

  if(!res.ok)throw new Error('Designspeicherung fehlgeschlagen');
  return await res.json();
}
function serviceVariantFor(req){return printServiceMap.get(`${req.key}|${req.tier}`)||null}
async function buildShopifyCartItems(){
  const sizes=orderedSizes();
  if(!sizes.length)throw new Error('Bitte mindestens eine Grösse auswählen.');
  const persisted=await persistDesignForOrder();
  await loadPrintServiceMap();
  const items=[];
  for(const row of sizes){
    const variant=await resolveVariant(row.size);
    if(!variant)throw new Error(`Keine Shopify-Variante für ${currentColor.name} / ${row.size} gefunden.`);
    items.push({
      id:Number(variant.id),
      quantity:row.qty,
      properties:{
        '_Swiss-Crafting Design-ID':persisted.designId,
        'Personalisierung':'Ja',
        'Farbe':currentColor.name,
        'Grösse':row.size,
        '_Produktionsdaten':persisted.productionUrl||'',
        '_Kundenvorschau Vorderseite':persisted.previewFrontUrl||'',
        '_Kundenvorschau Rückseite':persisted.previewBackUrl||'',
        '_Kundenvorschau Ärmel links':persisted.previewLeftSleeveUrl||'',
        '_Kundenvorschau Ärmel rechts':persisted.previewRightSleeveUrl||'',
        '_Konfigurator':'V11'
      }
    });
  }

  // Print service lines: one service line per printed garment and print position.
  const totalQty=sizes.reduce((a,x)=>a+x.qty,0);
  const req=printChargeRequirements(totalQty);
  const missing=req.filter(r=>!serviceVariantFor(r));
  if(missing.length){
    const names=missing.map(x=>`${x.label} (${x.tier})`).join(', ');
    throw new Error(
      'Im Shopify-Produkt „Druckservice Konfigurator“ fehlen Varianten: '+names+'. Der Checkout wurde zum Schutz vor falschen Preisen gestoppt.'
    );
  }
  for(const r of req){
    items.push({
      id:Number(serviceVariantFor(r)),
      quantity:totalQty,
      properties:{
        '_Swiss-Crafting Design-ID':persisted.designId,
        'Druckposition':r.label,
        '_Preisstaffel':r.tier
      }
    });
  }
  return items;
}
async function addToShopifyCart(){
  const btn=document.getElementById('cartTop');
  const old=btn.textContent;btn.disabled=true;btn.textContent='Warenkorb wird vorbereitet …';
  try{
    const items=await buildShopifyCartItems();
    const res=await fetch(shopUrl('/cart/add.js'),{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items})
    });
    if(!res.ok){
      const t=await res.text();
      throw new Error(`Shopify Warenkorb: ${res.status} ${t.slice(0,180)}`);
    }
    if(location.hostname.endsWith('swiss-crafting.ch')) location.href='/cart';
    else alert(`Shopify-Verknüpfung funktioniert. ${items.length} Warenkorbpositionen vorbereitet.\n\nIm lokalen Prototyp wird nicht auf den Live-Warenkorb umgeleitet.`);
  }catch(e){
    console.error(e);
    alert(e.message);
  }finally{
    btn.disabled=false;btn.textContent=old;
  }
}

document.getElementById('saveBtn').onclick=exportDesign;document.getElementById('productionBtn').onclick=exportProductionPackage;document.getElementById('cartBtn').onclick=addToShopifyCart;document.getElementById('cartTop').onclick=addToShopifyCart;

window.addEventListener('resize',()=>{clearTimeout(window.__rt);window.__rt=setTimeout(sizeCanvas,120)});
renderProductOptions();ensureSurfaceButtons();renderQuickPositions();setTimeout(()=>{applyProduct();sizeCanvas();history.front=[serialize()];history.back=[];history.leftSleeve=[];history.rightSleeve=[];calcPrice();updateUndoButtons();syncSelection();updateProductionStatus();refreshShopifyStatus();loadPrintServiceMap().then(updatePrintChargeStatus).catch(()=>updatePrintChargeStatus())},180);
})();
